export default __webpack_public_path__ + "static/media/RightChevron.48c09220.svg";